export default "__VITE_ASSET__BHLfe4oi__"